import {
    DateRelativeToNowOptions,
    useDateRelativeToNow,
} from 'custom_hooks/useDateRelativeToNow';
import { useUserDateTimeFormat } from 'custom_hooks/useUserDateTimeFormat';
import { useMemo } from 'react';

export type DateRelativeToNowProps = DateRelativeToNowOptions;

/**
 * Formats a date relative to supplied date.  Defaults to recalculating every
 * minute if `updateMillis` is not supplied.
 */
export function DateRelativeToNow(props: DateRelativeToNowProps) {
    const { date } = props;
    const { formatDateTime } = useUserDateTimeFormat();
    const description = useDateRelativeToNow(props);

    const title = useMemo(
        () => (date ? formatDateTime(date) : ''),
        [date, formatDateTime],
    );

    return (
        <time title={title} dateTime={title}>
            {description}
        </time>
    );
}
